<template>
  <div class="flex flex-col gap-6">
    <ShowcasesFormBanner />
    <BaseCard>
      <div
        class="py-8 flex flex-col space-y-4 justify-center items-center text-center"
      >
        <div v-if="showcase" class="max-w-md sm:whitespace-pre-line">
          <template
            v-if="
              showcase.requests_availability ===
              ShowcaseRequestsAvailability.Early
            "
          >
            {{ $t('showcases.availability_early', { date: startDate }) }}
          </template>
          <template
            v-else-if="
              showcase.requests_availability ===
              ShowcaseRequestsAvailability.Late
            "
          >
            {{ $t('showcases.availability_late') }}
          </template>
        </div>
        <BaseLocaleLink v-if="eventLink" :to="eventLink">
          <BaseButton theme="primary" look="border">
            {{ $t(`events.go_to_event`) }}
          </BaseButton>
        </BaseLocaleLink>
      </div>
    </BaseCard>
  </div>
</template>

<script setup lang="ts">
import { ShowcaseRequestsAvailability } from '~/models/showcases'
import { useShowcases } from '~/stores/showcases'
import { EventType } from '~/models/events'

const eventsStore = useEvents()
const { getHumanizedDate } = useDate()
const { showcase } = storeToRefs(useShowcases())

const eventLink = computed<string>(() => {
  return showcase.value
    ? eventsStore.getEventPageRoute(
        showcase.value.event.slug as string,
        EventType.Default
      )
    : ''
})

const startDate = computed<string>(() => {
  return getHumanizedDate(
    showcase.value?.requests_start_date || '',
    showcase.value?.event.timezone
  )
})
</script>
